import { render, staticRenderFns } from "./VaPageNotFoundLargeText.vue?vue&type=template&id=907628e8"
import script from "./VaPageNotFoundLargeText.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundLargeText.vue?vue&type=script&lang=js"
import style0 from "./VaPageNotFoundLargeText.vue?vue&type=style&index=0&id=907628e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports